/* assets/os-status.js — Shop open/closed state based on ET hours.
   Works alongside os-countdown.js (which feeds the mini timer and owns the
   weekend/holiday calendar). Holidays come from the status strip's
   "Holiday closures" settings via window.OSCountdown.

   Sub-line tokens (usable in any sub-line setting):
     {day}  -> next open weekday name, or "today" if the shop opens later today
     {date} -> next open date, e.g. "Tue, Sep 8"  */
(function(){
  function loadLuxon(cb){
    if(window.luxon){ cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/luxon@3/build/global/luxon.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function isWeekend(dt){ return dt.weekday === 6 || dt.weekday === 7; }
  function isHoliday(dt){
    return !!(window.OSCountdown && window.OSCountdown.isHoliday && window.OSCountdown.isHoliday(dt));
  }
  function isClosedDay(dt){ return isWeekend(dt) || isHoliday(dt); }

  // Next day the shop is open, starting today if it hasn't opened yet.
  function nextOpen(now, openHour){
    if(!isClosedDay(now) && now.hour < openHour) return { dt: now, today: true };
    var d = now.plus({ days: 1 }).startOf('day');
    for(var i = 0; i < 30 && isClosedDay(d); i++) d = d.plus({ days: 1 });
    return { dt: d, today: false };
  }

  function fillTokens(str, next){
    return String(str || '')
      .replace(/\{day\}/g,  next.today ? 'today' : next.dt.toFormat('cccc'))
      .replace(/\{date\}/g, next.dt.toFormat('ccc, LLL d'));
  }

  function update(){
    var DateTime = window.luxon && window.luxon.DateTime;
    if(!DateTime) return;
    var now = DateTime.now().setZone('America/Detroit');
    var h = now.hour, m = now.minute;

    document.querySelectorAll('.os-status').forEach(function(root){
      var openHour = parseInt(root.dataset.openHour, 10) || 8;
      var closeHour = parseInt(root.dataset.closeHour, 10) || 16;
      var closeMin = 30; // 4:30 PM
      var weekend = isWeekend(now);
      var holiday = !weekend && isHoliday(now);
      var pastOpen = (h > openHour) || (h === openHour && m >= 0);
      var pastClose = (h > closeHour) || (h === closeHour && m >= closeMin);
      var open = !weekend && !holiday && pastOpen && !pastClose;
      var next = nextOpen(now, openHour);

      var cfg = {};
      var cfgEl = root.querySelector('.os-status-config');
      if(cfgEl){ try { cfg = JSON.parse(cfgEl.textContent); } catch(e){} }

      var dot = root.querySelector('[data-os-status-dot]');
      var lbl = root.querySelector('[data-os-status-label]');
      var sub = root.querySelector('[data-os-status-sub]');
      if(!dot || !lbl || !sub) return;

      if(open){
        dot.removeAttribute('data-closed');
        lbl.textContent = cfg.openLabel || 'Shop Open';
        sub.textContent = fillTokens(cfg.hoursLine || '', next);
      } else if(holiday){
        dot.setAttribute('data-closed','');
        lbl.textContent = cfg.holidayLabel || 'Holiday Closure';
        sub.textContent = fillTokens(cfg.holidaySub || 'Reopens {day} · 8am ET', next);
      } else if(weekend){
        dot.setAttribute('data-closed','');
        lbl.textContent = cfg.weekendLabel || 'Weekend Pause';
        sub.textContent = fillTokens(cfg.weekendSub || '', next);
      } else {
        dot.setAttribute('data-closed','');
        lbl.textContent = cfg.closedLabel || 'Shop Closed';
        sub.textContent = fillTokens(cfg.closedSub || '', next);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    loadLuxon(function(){
      update();
      setInterval(update, 30000); // every 30s is plenty
    });
  });
})();
